

export const SET_CLEAR_DATA = 'boilerplate/PREPAREGSTR9C/SET_CLEAR_DATA';
export const SET_GSTR9C_DATA ='boilerplate/PREPAREGSTR9C/SET_GSTR9C_DATA';
export const PROFILE_INFO = 'boilerplate/PREPAREGSTR9C/PROFILE_INFO';
export const SET_TOTAL_RECORD = 'boilderplate/PREPAREGSTR9C/SET_TOTAL_RECORD';
export const LOADER_STATUS = 'boilderplate/PREPAREGSTR9C/LOADER_STATUS';
export const SET_AUTO_POPULATED_HISTORY = 'boilderplate/PREPAREGSTR9C/SET_AUTO_POPULATED_HISTORY';
export const SET_GSTR9C_HISTORY = 'boilderplate/PREPAREGSTR9C/SET_GSTR9C_HISTORY';

